import { connect } from 'react-redux'
import PaymentList from '../components/PaymentList'
import { fetchPaymentsAction, fetchPaymentTotalsAction } from '../actions/paymentActions'

const mapStateToProps = (state, props) => {
  return {
    payments: state.payments.paymentList,
    totalAmountOwed: state.payments.totalAmountOwed,
    totalAmountPaid: state.payments.totalAmountPaid,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  return {
    fetchPayments: () => dispatch(fetchPaymentsAction(props.organization_id, props.resident_id)),
    fetchPaymentTotals: () => dispatch(fetchPaymentTotalsAction(props.organization_id, props.resident_id)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentList)
